<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑角色' : '添加角色'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm"  :model="item" label-width="auto">
			<el-form-item label="昵称">
				<el-input v-model="item.name" placeholder="请输入昵称"></el-input>
			</el-form-item>
			<el-form-item label="描述">
				<el-input v-model="item.description" placeholder="请输入描述"></el-input>
			</el-form-item>
			<el-form-item label="状态">
				<el-radio v-model="item.status" label="1">正常</el-radio>
				<el-radio v-model="item.status" label="2">弃用</el-radio>
			</el-form-item>
			<el-form-item label="权限">
				<el-tree
					  :data="data"
					  show-checkbox
					  default-expand-all
					  node-key="id"
					  ref="tree"
					  :default-checked-keys="permission"
					  highlight-current
					  :props="defaultProps">
				</el-tree>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>
			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>您确认保存嘛</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {status:'1'},
				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				data: [],
				defaultProps: {
					children: 'child',
					label: 'name'
				},
				permission: [],
				rules:{
				}
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ''

				res = await this.axios.get('/admin/data/menuListTreeData', {})
				this.data = res.data.list

				if (this.id) {
					res = await this.axios.get('/admin/role/detail', {
						params:  {
							id: this.id
						}
					})
					this.item = res.data.detail
					this.item.status = this.item.status.toString()
					var permission = this.item.permission.split(',')
					this.permission = this.initPermission(permission)
				}

				this.isLoad = false
			},

			initPermission: function (permission) {

				const isContained = (a, b) => {
					// a和b其中一个不是数组，直接返回false
					if (!(a instanceof Array) || !(b instanceof Array)) return false;
					const len = b.length;
					// a的长度小于b的长度，直接返回false
					if (a.length < len) return false;
					for (let i = 0; i < len; i++) {
						// 遍历b中的元素，遇到a没有包含某个元素的，直接返回false
						if (!a.includes(b[i])) return false;
					}
					// 遍历结束，返回true
					return true;
				}

				var data = this.data
				function getChild(item) {
					var ids = [];
					if (item.child && item.child.length > 0) {
						item.child.forEach(function (row) {
							var _ids = getChild(row)
							ids = ids.concat(_ids)
							ids.push(row.id)
						})
					}

					var ids = ids.sort()
					var flag = isContained(permission, ids)
					if (false == flag) {
						del.push(item.id)
					}

					item.ids = ids;
					return ids;
				}

				function makeTree(item) {
					var ids = getChild(item)
					return ids;
				}

				var del = []
				data.forEach(function (item) {
					var ids = makeTree(item)
					item.ids = ids
				})
				del.forEach(function (id) {
					var index = permission.findIndex(function (per) {
						return per == id
					})

					if (index != -1) {
						permission.splice(index, 1)
					}
				})
				return permission;
			},

			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.item.permission = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
				this.item.permission = this.item.permission.join(',')
				let url = ''
				if (this.id) {
					url = '/admin/role/edit'
					this.item.id = this.id
					this.axios.put(url, this.item)
						.then(() => {
							this.isLoad = !this.isLoad
							this.$message.success({
								message: '保存成功'
							});
							this.goBack()
						})
						.catch(() => {
							this.isLoad = !this.isLoad
						})
				} else {
					url = '/admin/role/add'
					this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
				}

			},
		}
	}
</script>
<style scoped>
</style>
